<template>
  <div class="complex-wrap">
    <el-button v-if="key === 'wireless_desc'" @click="importPC">导入PC描述</el-button>
    <el-button v-if="key === 'wireless_desc'" @click="handleOpenPictureZone">从素材空间上传</el-button>
    <div style="font-size: 12px;">拖动可调整顺序 <BatchEditImages v-model="value" @change="onChange" refName="imgs" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
    <MutiImgUpload
      ref="imgs"
      :mainImgNums="0"
      :imgs="value"
      :appendToBody="true"
      v-bind="extraAttr"
      @change="onChange"
       />
    <div
      class="tips"
      v-if="hasTips"
      v-html="tips">
    </div>
    <ChoosePictrueZone v-show="choosePictrueZoneVisible" ref="choosePictrueZoneRef"/>
    <ChooseNewPictrueZone v-show="chooseNewPictrueZoneVisible" :appendToBody="true" ref="chooseNewPictrueZoneRef"/>
  </div>
</template>

<script>
import MutiImgUpload from '@/components/Uploads/MutiImgUpload'
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import ChoosePictrueZone from "@/components/Uploads/ChoosePictrueZone.vue";
import ChooseNewPictrueZone from "@/components/Uploads/ChooseNewPictrueZone.vue";

export default {
  components: {
    MutiImgUpload,
    BatchEditImages,
    ChoosePictrueZone,
    ChooseNewPictrueZone,
  },
  props: ['props', 'value', 'form'],
  inject: { injectedOuterId: { default: () => '', from: 'outerId' } },
  data(){
    return {
      choosePictrueZoneVisible: false,
      chooseNewPictrueZoneVisible: false
    }
  },
  computed: {
    key() {
      return this.props.name
    },
    tips() {
      return this.props.tipRule || ''
    },
    hasTips() {
      return this.tips.length
    },
    extraAttr() {
      return this.props.extraAttr || {}
    },
    // 与上传组件保持一致：根据公司注册时间切换新旧素材空间
    useNewPictureZone() {
      let companyCreated = 0;
      try {
        const raw = window.localStorage.getItem('userinfo');
        if (raw) {
          const u = JSON.parse(raw);
          companyCreated = Number(u && u.companyCreated) || 0;
        }
      } catch (e) {}
      const START_TS = new Date(2026, 2, 1, 0, 0, 0).getTime();
      return companyCreated >= START_TS;
    },
    productCodeResolved() {
      const f = this.form || {};
      return f.baseItemId || f.productId || f.id || f.erpSysItemId || ''
    }
  },
  methods: {
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
    onChange(v) {
      this.$emit('change', v)
    },
    importPC() {
      let pcHtml = '';
      for (const key in this.form) {
        if ((/^desc_module.*_content$/.test(key) || key === 'description') && this.form[key]) {
          pcHtml += this.form[key];
        }
      }
      if (!pcHtml) {
        return this.$message.error('请先补充商品描述')
      }

      let div = document.createElement('div')
      div.innerHTML = pcHtml
      let imgs = Array.from(div.getElementsByTagName('img'))
      if (!imgs.length) {
        return this.$message.error('商品描述中暂无可用图片')
      }
      this.onChange(JSON.parse(JSON.stringify(imgs.map(i => i.src))))
      this.$nextTick(() => {
        this.$parent.validate((valid) => {
          console.log(valid,'----valid---')
        })
      })
    },
    openPictureZone() {
      const that = this;
      this.choosePictrueZoneVisible = true
      this.$nextTick(() => {
        this.$refs.choosePictrueZoneRef.method_open({
          // limitSuffix: this.limitSuffix,
          isSingle: false,
          okFn(urlList) {
            let urls = urlList.map(item => item.url)
            let imgs = [...that.value,...urls]
            that.onChange(imgs)
          },
        })
      })
    },
    openNewPictureZone() {
      const that = this;
      this.chooseNewPictrueZoneVisible = true
      this.$nextTick(() => {
        this.$refs.chooseNewPictrueZoneRef.method_open({
          isSingle: false,
          productCode: this.productCodeResolved,
          outerId: this.injectedOuterId,
          folderId: localStorage.getItem('km_picture_folder_id') || '',
          okFn(fileList) {
            const urls = fileList.map(item => item.url)
            const imgs = [...that.value, ...urls]
            that.onChange(imgs)
          },
        })
      })
    },
    // 统一入口：根据注册时间切换新旧素材空间
    handleOpenPictureZone() {
      // if (this.useNewPictureZone) {
        this.openNewPictureZone();
      // } else {
        // this.openPictureZone();
      // }
    },
  },
  mounted() {
    const watcher = this.$watch('extraAttr', (v) => {
      if (v._needLimit) {
        this.$parent.rules.push({
          validator: async (rule, value, callback) => {
            let errMsg = await this.$refs.imgs.method_validImage()
            if (errMsg) {
                callback(new Error(errMsg));
            } else {
                callback();
            }
          }
        })
      }
      this.$nextTick(() => {
        watcher && watcher();
      })
    }, {
      immediate: true
    })
  }
};
</script>

<style lang="scss" scoped>
.tips {
  font-size: 12px;
  color: #a5a5a5;
}
</style>